import { useContext } from 'react';
import CompositionRowField from '../CompositionRowField';
import styles from './NewCompositionRow.module.css';
import ThemeContext from 'config/context/themeContext';
import { CancelSmallIcon } from 'features/compositions/assets/icons/icons';
import { useCompositionsContext } from 'features/compositions/context/CompositionsContext';

const NewCompositionRow = ({ rowIndex, rowData, setNewRowsData }) => {
  const { dark } = useContext(ThemeContext);
  const { selectedComposition } = useCompositionsContext();

  const handleFieldChange = (fieldName, value) => {
    setNewRowsData(prev => {
      const updated = [...prev];
      updated[rowIndex] = {
        ...updated[rowIndex],
        [fieldName]: value
      };
      return updated;
    });
  };

  const handleCancelRow = () => {
    setNewRowsData(prev => {
      const updated = [...prev];
      updated.splice(rowIndex, 1);
      return updated;
    });
  };

  return (
    <div className={`${styles.new_composition_row} ${dark ? styles.dark : ''}`}>
      <button
        className={styles.cancel_row_btn}
        onClick={handleCancelRow}
      >
        <CancelSmallIcon />
      </button>

      {selectedComposition?.structure?.indexes.map((i) => (
        <div className={styles.field} key={i.meta_name}>
          {i?.ai ? (
            <span className={styles.non_editable_field_text}>AI FIELD</span>
          ) : i?.is_auto_created ? (
            <span className={styles.non_editable_field_text}>AC FIELD</span>
          ) : i?.is_auto_updated ? (
            <span className={styles.non_editable_field_text}>AU FIELD</span>
          ) : (
            <CompositionRowField
              type={i?.type}
              name={i?.name}
              value={rowData?.[i.name] || ""}
              onChange={(value) => handleFieldChange(i.name, value)}
              isEditable={!i?.ai && !i?.is_auto_created && !i?.is_auto_updated}
              isArray={!!i?.is_array}
              fieldDefinition={i}
            />
          )}
        </div>
      ))}
      {selectedComposition?.structure?.fields.map((i) => (
        <div className={styles.field} key={i.meta_name}>
          {i?.ai ? (
            <span className={styles.non_editable_field_text}>AI FIELD</span>
          ) : i?.is_auto_created ? (
            <span className={styles.non_editable_field_text}>AC FIELD</span>
          ) : i?.is_auto_updated ? (
            <span className={styles.non_editable_field_text}>AU FIELD</span>
          ) : (
            <CompositionRowField
              type={i?.type}
              name={i?.name}
              value={rowData?.[i.name] || ""}
              onChange={(value) => handleFieldChange(i.name, value)}
              isEditable={!i?.ai && !i?.is_auto_created && !i?.is_auto_updated}
              isObject={!!i?.is_object}
              isArray={!!i?.is_array}
              fieldDefinition={i}
            />
          )}
        </div>
      ))}
    </div>
  )
}

export default NewCompositionRow;